import { useGetOnboardingStatus } from "@src/components/onboarding/queries/get-onboarding-status";
import { StepsFilter } from "@src/gql/graphql";
import { selectIntroVideosStep } from "./onboarding-step-selectors";

export function useIntroVideosStepCompleted(): boolean {
	const { data } = useGetOnboardingStatus(StepsFilter.All);
	const step = selectIntroVideosStep(data);
	return step?.isCompleted ?? false;
}
